import React from "react";
import styled from "styled-components";
import { Form, Table as BsTable } from "react-bootstrap";
import { currencyFormat, parseCurrency } from "../../../../utils/numberUtils";
import { DetalleProducto } from "../Model";
import CurrencyFormat from "react-currency-format";

function Table({
  items,
  onProductoValorChange,
  total,
}: {
  items: Map<string, DetalleProducto>;
  onProductoValorChange: (idProducto: string, valor: number) => void;
  total: number;
}) {
  return (
    <StyledTable responsive hover>
      <thead>
        <tr>
          <StyledColHeader>Producto</StyledColHeader>
          <StyledColHeader>Valor Unitario</StyledColHeader>
          <StyledColHeader>Cantidad</StyledColHeader>
          <StyledColHeader>Subtotal</StyledColHeader>
        </tr>
      </thead>
      <tbody>
        {Array.from(items.keys()).map((id, i) => (
          <TableItem
            key={i}
            producto={items.get(id)!}
            onValorChange={onProductoValorChange}
            idProducto={id}
          />
        ))}
        <StyledRow>
          <StyledCell colSpan={3}>
            <strong>Total</strong>
          </StyledCell>
          <StyledCell>
            <strong>{currencyFormat(total)}</strong>
          </StyledCell>
        </StyledRow>
      </tbody>
    </StyledTable>
  );
}

function TableItem({
  idProducto,
  producto,
  onValorChange,
}: {
  idProducto: string;
  producto: DetalleProducto;
  onValorChange: (idProducto: string, valor: number) => void;
}) {
  return (
    <StyledRow>
      <StyledCell className="col-2">{producto.nombre}</StyledCell>
      <StyledCell className="col-1">
        <CurrencyFormat
          customInput={Form.Control}
          name="valor"
          value={producto.valor}
          thousandSeparator={","}
          required
          onChange={({ target }: any) => {
            onValorChange(idProducto, parseCurrency(target.value, "$", ","));
          }}
          prefix={"$"}
          decimalSeparator={"."}
        />
      </StyledCell>
      <StyledCell className="col-1">{producto.cantidad}</StyledCell>
      <StyledCell className="col-1">
        {currencyFormat(producto.cantidad * producto.valor)}
      </StyledCell>
    </StyledRow>
  );
}

const StyledTable = styled(BsTable)``;

const StyledCell = styled("td")``;

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledRow = styled("tr")`
  cursor: pointer;
`;

export default Table;
